// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2oudW","rootSuccess":"CompleteLink_rootSuccess__3ROJx","rootFailure":"CompleteLink_rootFailure__3eUFK","isDisabled":"CompleteLink_isDisabled__1wuFw"};